"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionCardImageDir = void 0;
/**
 * 多维表卡片显示的时候图片方向
 */
var CollectionCardImageDir;
(function (CollectionCardImageDir) {
    CollectionCardImageDir["HORIZONTAL"] = "horizontal";
    CollectionCardImageDir["VERTICAL"] = "vertical";
})(CollectionCardImageDir = exports.CollectionCardImageDir || (exports.CollectionCardImageDir = {}));
